/* -------------------------------------------------------------------------------------------------
 * IProcoreModel
 * -----------------------------------------------------------------------------------------------*/

export interface IProcoreModel {
    _id: string;
    client: string;
    user: string;
    token: string;
    createdAt: string;
}

/* -------------------------------------------------------------------------------------------------
 * ProcoreModel
 * -----------------------------------------------------------------------------------------------*/
export class ProcoreModel {
    _id: string;
    client: string;
    user: string;
    token: string;
    createdAt: string;

    constructor(data: Partial<IProcoreModel>) {
        this._id = data._id ?? '';
        this.client = data.client ?? '';
        this.user = data.user ?? '';
        this.token = data.token ?? '';
        this.createdAt = data.createdAt ?? '';
    }

    static fromObject(data: Partial<IProcoreModel>): ProcoreModel {
        const model = new ProcoreModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IProcoreModel>[]): ProcoreModel[] {
        return data.map((row) => ProcoreModel.fromObject(row));
    }

    static cloneFrom(data: Partial<IProcoreModel>): ProcoreModel {
        const model = new ProcoreModel(data);

        return model;
    }

    toObject(): IProcoreModel {
        const data: IProcoreModel = {
            _id: this._id,
            client: this.client,
            user: this.user,
            token: this.token,
            createdAt: this.createdAt,
        };

        return data;
    }
}
